import { render, staticRenderFns } from "./CredentialSampleConfig.vue?vue&type=template&id=642749cd&scoped=true&"
import script from "./CredentialSampleConfig.vue?vue&type=script&lang=js&"
export * from "./CredentialSampleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642749cd",
  null
  
)

export default component.exports